/** @jsx jsx */
import React from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';

import { grayScale } from 'components/styles';

const style = css({
  // margin: '8px 16px',
  // padding: '20px 24px',
  backgroundColor: '#FFFFFF',
  border: `1px solid ${grayScale.gray20}`,
  borderRadius: '10px',
  marginBottom:'20px',
});

const subStyle = css({
  margin: '5px 10px',
  padding: '5px 10px',
  backgroundColor: '#FFFFFF',
  border: `1px solid ${grayScale.gray20}`,
  borderRadius: '10px',
});

/**
 * フォームのコンテンツ
 */
const FormContents: React.FC<{
  isSubForm?: boolean,
  customStyle?:any,
  titleForm?:string,
  customTitleStyle?: SerializedStyles,
}> = ({
  children,
  isSubForm = false,
  customStyle,
  titleForm = '',
  customTitleStyle = css({})
}) => (
  <div css={isSubForm ? css(subStyle, customStyle) : css(style, customStyle)}>
    <div css={[css({
      fontWeight: 'bold',
      fontSize: '16px',
      // marginBottom: '25px',
      color: grayScale.gray60,
    }), customTitleStyle]}
    >
      {titleForm}
    </div>
    {children}
  </div>
);

export default FormContents;
